import { lazy } from 'react';

export const AssociationSelection = lazy(() => import('./AssociationSelection/AssociationSelection'));
export const AtonementAmountSelection = lazy(() => import('./AtonementAmountSelection/AtonementAmountSelection'));
export const Payment = lazy(() => import('./Payment'));
export const PersonalDetails = lazy(() => import('./PersonalDetails'));
export const KitSelection = lazy(() => import('./SetSelection/SetSelection'));
export const ItemSelection = lazy(() => import('./SetSelection/ItemSelection'));
export const StationSelection = lazy(() => import('./StationSelection/StationSelection'));
export const StepNavigation = lazy(() => import('./StepNavigation'));
export const OrderSummary = lazy(() => import('./OrderSummary/OrderSummary'));